import { createFileRoute } from '@tanstack/react-router'

import PendingComponent from '@/components/pending-component'
import { synopticsQuery } from '@/queries/synoptics.query'

export const Route = createFileRoute('/_dashboard/admin/synoptics/')({
  loader({ context }) {
    return context.queryClient.ensureQueryData(synopticsQuery({ unlocated: true }))
  },
  pendingComponent: PendingComponent,
})
